export const DOMAIN =
  process.env.NODE_ENV === "production" || process.env.NODE_ENV === "test"
    ? window.location.origin || "https://www.cleartrip.ae"
    : `http://localhost:3031`;
